import { createSlice } from "@reduxjs/toolkit";
import {
  addFirmwareAPI,
  editFirmwareAPI,
  getFirmwareListAPI,
} from "../helpers/firmwareAPI";

const initialState = {
  firmwareData: [],
};

export const firmwareSlice = createSlice({
  name: "firmware",
  initialState,
  reducers: {
    resetStateFirmware: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFirmwareListAPI.fulfilled, (state, action) => {
        console.log(action, "editFirmwareAPI");
        state.firmwareData = action.payload.data;
      })
      .addCase(getFirmwareListAPI.rejected, (state, action) => {
        console.log(action, "editFirmwareAPI");
        state.firmwareData = [];
      })
      .addCase(addFirmwareAPI.fulfilled, (action) => {
        console.log(action, "addFirmwareAPI");
      })
      .addCase(addFirmwareAPI.rejected, (action) => {
        console.log(action, "addFirmwareAPI");
      })
      .addCase(editFirmwareAPI.fulfilled, (action) => {
        console.log(action, "editFirmwareAPI");
      })
      .addCase(editFirmwareAPI.rejected, (action) => {
        console.log(action, "editFirmwareAPI");
      });
  },
});

export const { resetStateFirmware } = firmwareSlice.actions;

export default firmwareSlice.reducer;
